<div
  class="quote-message bg-surface-100 dark:bg-surface-600"
  [ngClass]="{
    'my-quote-message': quoteMessage().cite.createdBy === chatAuthService.userId
  }"
  [ngStyle]="{ 'max-width': getChatMessageMaxWidth() }"
  data-e2e="quote-message"
>
  <div
    class="quoted-border"
    [ngClass]="{
      'my-quote-border': quoteMessage().cite.createdBy === chatAuthService.userId
    }"
  ></div>
  <div
    class="quoted-body"
    [ngClass]="{
      'my-content': quoteMessage().cite.createdBy === chatAuthService.userId
    }"
  >
    <div class="quote-cite" #quotecitebody [innerHTML]="quoteMessage().cite.body | linky"></div>
    <div class="quote-info">
      <span class="quote-info-name">{{ chatAdminService.displayNames[quoteMessage().cite.createdBy] }}</span>
      @if (quoteDate() && !quoteDateToday()) {
        <span class="quote-date" translate [translateParams]="{ date: quoteDate(), time: quoteTime() }">
          cl_chat.dateAtTime
        </span>
      }
      @if (quoteDate() && quoteDateToday() && quoteTime()) {
        <span class="quote-date">
          {{ quoteTime() }}
        </span>
      }
      @if (!previewMode()) {
        <button
          class="quote-info-go button-remove-style"
          (click)="goToQuotedMessage()"
          (keydown.enter)="goToQuotedMessage()"
          data-e2e="quote-info-go"
        >
          {{ 'cl_chat.viewConversation' | translate }}
        </button>
      }
    </div>
  </div>
</div>
